/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CaseItemTag = zod
	.object({
		assigned_by_id: zod.string().nullable().describe('User who assigned the tag'),
		case_id: zod.string().describe('Associated case ID'),
		case_item_id: zod.string().describe('Associated case item ID'),
		confidence: zod.number().nullable().describe('Normalized confidence score (0-1)'),
		id: zod.string().describe('Case tag ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		organization_id: zod.string().describe('Organization ID'),
		tag: zod
			.object({
				description: zod.string().nullable().describe('Tag description'),
				formats: zod.array(zod.string()).describe('Content formats this tag applies to'),
				id: zod.string().describe('Tag ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				key: zod.string().describe('Tag key identifier'),
				name: zod.string().describe('Tag name'),
				organization_id: zod.string().nullable().describe('Organization ID'),
				source: zod.string().describe('Tag source (builtin or custom)'),
				suggested_severity: zod.number().nullable().describe('Suggested severity level (0-5)'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('A tag for categorizing and organizing case items'),
		tag_id: zod.string().describe('Associated tag ID'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('A tag association for a case item');

export type CaseItemTag = zod.input<typeof CaseItemTag>;
export type CaseItemTagOutput = zod.output<typeof CaseItemTag>;
